
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  reactive,
  toRefs,
} from 'vue'
import { useStore } from 'vuex'
import Form from './Form.vue'

export default defineComponent({
  components: {
    Form,
  },
  setup () {
    const form = reactive({
      id: '',
      name: '',
    })
    const form_action = ref('save')
    const visible = ref(false)
    const store = useStore()
    const fields = ref([
      {
        title: 'Tax Type Name',
        dataIndex: 'name',
      },
      // {
      //   title: "Is Active",
      //   dataIndex: "is_active",
      //   align: 'center',
      //   slots: { customRender: "is_active" }
      // },
      {
        title: 'Action',
        dataIndex: 'action',
        slots: {customRender: 'action'},
        align: 'center'
      },
    ])

    const index = (payload = {page: 1}) => {
      store.dispatch('TaxType/index', payload)
    }

    const editRecord = (record: any) => {
      form_action.value = 'update'
      const {id, name} = toRefs(form)
      id.value = record.id
      name.value = record.name
      visible.value = true
    }

    const createRecord = () => {
      form_action.value = 'save'
      const {id, name} = toRefs(form)
      id.value = ''
      name.value = ''
      visible.value = true
    }

    const deleteRecord = (record: any) => {
      store.dispatch('TaxType/destroy', record.id)
    }

    const handleSaving = (record: any) => {
      form_action.value == 'save' ? storeRecord(record) : updateRecord(record)
    }

    const storeRecord = (payload = {}) => {
      store
          .dispatch('TaxType/store', payload)
          .then(() => (visible.value = false))
    }

    const updateRecord = (payload = {}) => {
      store
          .dispatch('TaxType/update', payload)
          .then(() => (visible.value = false))
    }

    const filterRecord = (payload: any) => {
      index(payload)
    }

    const items = computed(() => store.getters['TaxType/items'])
    const loading = computed(() => store.getters['TaxType/status'])

    onMounted(index)

    return {
      loading,
      items,
      fields,
      visible,
      form,
      editRecord,
      deleteRecord,
      storeRecord,
      createRecord,
      updateRecord,
      handleSaving,
      filterRecord
    }
  },
})
